import React, { Ref, forwardRef } from 'react';
import { FormToggle } from '@spotify-internal/encore-web';
import { FieldController } from 'shared/FieldController';
import { FieldToggleProps, ControlledFieldToggleProps } from './types';

export const FieldToggle = forwardRef(
  (
    { value, containerClassName, label, ...props }: FieldToggleProps,
    ref: Ref<HTMLElement>
  ) => {
    const checked = typeof value === 'string' ? value.length > 0 : value;
    return (
      <div className={containerClassName}>
        <FormToggle ref={ref} checked={checked} {...props}>
          {label}
        </FormToggle>
      </div>
    );
  }
);

export const ControlledFieldToggle = (props: ControlledFieldToggleProps) => (
  <FieldController<FieldToggleProps, HTMLInputElement>
    as={FieldToggle}
    {...props}
  />
);
